import { useState } from "react";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Team } from "@/types";
import { EditTeamDialog } from "./EditTeamDialog";
import { TeamMembersDialog } from "./TeamMembersDialog";
import { UsersIcon, PencilIcon } from "lucide-react";

interface TeamCardProps {
  team: Team;
}

export function TeamCard({ team }: TeamCardProps) {
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [isMembersDialogOpen, setIsMembersDialogOpen] = useState(false);

  const handleTeamUpdated = async () => {
    setIsEditDialogOpen(false);
  };

  return (
    <>
      <Card className="flex flex-col h-full">
        <CardHeader className="pb-3">
          <div className="flex justify-between items-start">
            <CardTitle className="text-xl">{team.name}</CardTitle>
            {team.logo_url && (
              <div className="h-10 w-10 rounded overflow-hidden">
                <img
                  src={team.logo_url}
                  alt={`${team.name} logo`}
                  className="h-full w-full object-contain"
                />
              </div>
            )}
          </div>
          {team.website && (
            <a
              href={
                team.website.startsWith("http")
                  ? team.website
                  : `https://${team.website}`
              }
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-blue-500 hover:underline"
            >
              {team.website}
            </a>
          )}
        </CardHeader>
        <CardContent className="flex-grow">
          {/* Card content area - can be used for additional team information in the future */}
        </CardContent>
        <CardFooter className="flex justify-between pt-3 border-t">
          <Button
            variant="outline"
            size="sm"
            onClick={() => setIsMembersDialogOpen(true)}
          >
            <UsersIcon className="h-4 w-4 mr-2" />
            Members
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={() => setIsEditDialogOpen(true)}
          >
            <PencilIcon className="h-4 w-4 mr-2" />
            Edit
          </Button>
        </CardFooter>
      </Card>

      <EditTeamDialog
        open={isEditDialogOpen}
        onOpenChange={setIsEditDialogOpen}
        team={team}
        onTeamUpdated={handleTeamUpdated}
      />

      <TeamMembersDialog
        open={isMembersDialogOpen}
        onOpenChange={setIsMembersDialogOpen}
        team={team}
      />
    </>
  );
}
